import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { CarouselDotsComponent } from './carousel-dots/carousel-dots.component';
import { CarouselSlideDirective } from './carousel-slide.directive';
import { CarouselComponent } from './carousel.component';

@NgModule({
    declarations: [CarouselComponent, CarouselSlideDirective, CarouselDotsComponent],
    imports: [CommonModule, SwiperModule],
    exports: [CarouselComponent, CarouselSlideDirective, CarouselDotsComponent]
})
export class CarouselModule { }
